/** DRAWING */
export const DRAWING_START_MARK = 'drawing_start';
export const DRAWING_TIME_MEASURE = 'drawing_time';

/** FRAME */
export const FRAME_START_MARK = 'frame_start';
export const FRAME_TIME_MEASURE = 'frame_time';

/** RTC-connection */
export const CONNECTION_START_MARK = 'connection_start';
export const CONNECTION_TIME_MEASURE = 'success_connection';
